'use client';

import { useState, useEffect } from 'react';
import { contentSectionAPI } from '@/services/api';

const ContentPagesLinks = () => {
  const [contentPages, setContentPages] = useState([]);

  useEffect(() => {
    fetchContentPages();
  }, []);

  const fetchContentPages = async () => {
    try {
      const response = await contentSectionAPI.getAllContentSections();
      // Filter only active content pages
      const activePages = response.filter(page => page.isActive);
      setContentPages(activePages);
    } catch (error) {
      console.error('Error fetching content pages:', error);
      // Set an empty array if there's an error
      setContentPages([]);
    }
  };

  // Organize content pages by categories
  const aboutPages = contentPages.filter(page => 
    ['about-us', 'contact-us', 'faq'].includes(page.sectionName.toLowerCase())
  );
  
  const supportPages = contentPages.filter(page => 
    ['help-center', 'customer-support', 'complaints-policy', 'technical-support', 'refund-policy', 'cancellation-policy'].includes(page.sectionName.toLowerCase())
  );
  
  const legalPages = contentPages.filter(page => 
    ['Terms & Conditions', 'privacy-policy', 'cookie-policy', 'disclaimer'].includes(page.sectionName.toLowerCase())
  );
  console.log('data content', legalPages,supportPages,aboutPages)
  return (
    <div className="">
      {aboutPages.length > 0 && (
        <div>
          <h4 className="text-white text-xl font-semibold mb-4">About</h4>
          <ul>
            {aboutPages.map((page) => (
              <li key={page.id} className="mb-2">
                <a 
                  href={`/content/${page.sectionName}`} 
                  className="text-white hover:text-gray-200"
                >
                  {page.sectionName.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}dd
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {supportPages.length > 0 && (
        <div>
          <h4 className="text-white text-xl font-semibold mb-4">Support</h4>
          <ul>
            {supportPages.map((page) => (
              <li key={page.id} className="mb-2">
                <a 
                  href={`/content/${page.sectionName}`} 
                  className="text-white hover:text-gray-200"
                >
                  {page.sectionName.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}ee
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {contentPages.length > 0 && (
        <div>
          <h4 className="text-white text-xl font-semibold mb-4">Content</h4>
          <ul>
            {contentPages.map((page) => (
              <li key={page.id} className="mb-2">
                <a 
                  href={`/content/${page.sectionName}`} 
                  className="text-white hover:text-gray-200"
                >
                  {page.sectionName}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {contentPages.length === 0 && (
        <div className="col-span-3 text-center py-4">
          <p className="text-gray-300">No content pages available</p>
        </div>
      )}
    </div>
  );
};

export default ContentPagesLinks;